import { createContext, useContext, useState } from 'react';

const CartContext = createContext(null);

// Calcula soma dos adicionais de um item (já multiplicado pela qty do item)
function precoAdicionais(item) {
  const ad = item.adicionais || [];
  const somaAd = ad.reduce((s, a) => s + (Number(a.preco) * (a.quantidade || 1)), 0);
  return somaAd * item.qty;
}

function precoItem(item) {
  return (Number(item.preco) * item.qty) + precoAdicionais(item);
}

export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);

  const addItem = (produto) => setCart(prev => {
    const exists = prev.find(i => i.id === produto.id);
    return exists
      ? prev.map(i => i.id === produto.id ? { ...i, qty: i.qty + 1 } : i)
      : [...prev, { ...produto, qty: 1, adicionais: [], remover: [], observacao: '' }];
  });

  const removeItem = (id) => setCart(prev => prev.filter(i => i.id !== id));

  const changeQty = (id, delta) => setCart(prev =>
    prev.map(i => i.id === id ? { ...i, qty: i.qty + delta } : i).filter(i => i.qty > 0)
  );

  const updateItemOpts = (id, opts) => setCart(prev =>
    prev.map(i => i.id === id ? { ...i, ...opts } : i)
  );

  const clearCart = () => setCart([]);

  const totalItems = cart.reduce((a, i) => a + i.qty, 0);
  const subtotal   = cart.reduce((a, i) => a + precoItem(i), 0);
  const total      = subtotal + 3.00;

  return (
    <CartContext.Provider value={{
      cart, addItem, removeItem, changeQty, updateItemOpts, clearCart,
      totalItems, subtotal, total, precoItem, precoAdicionais
    }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
